import React from 'react'
import { Modal, Button, Grid, Radio, Dropdown, Input, Divider } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';

import { Form } from 'formsy-semantic-ui-react';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import ImageAvater from '../../../../drive/Components/ImageAvater';
// const _ = require('lodash');
class ChangeAccountableConfirmationModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.managers[0],
            managers: this.props.managers,
            members: this.props.members,
            searchText: '',
            newAssignee: this.props.newAssignee,
            radioValue: 0
        }
    }
    close = () => {
        this.props.close();
        this.setState({ radioValue: 0, searchText: '' })
    }
    searchUsers = (event, data) => {
        if (data.value) {
            let managers = this.props.managers.filter(manager => { return ((manager.firstName + " " + manager.lastName).toLowerCase().includes(data.value.toLowerCase())) })
            let members = this.props.members.filter(member => { return ((member.firstName + " " + member.lastName).toLowerCase().includes(data.value.toLowerCase())) })
            this.setState({ managers: managers, members: members, searchText: data.value })
        }
        else {
            this.setState({ managers: this.props.managers, members: this.props.members, searchText: '' })
        }

    }
    selectAccountableForCommunity = (associatedCommunity, e, data) => {
        this.setState({ associatedCommunity: associatedCommunity, newAssignee: data.value })
    }
    assignNewUser = async () => {
        dispatch.initiatives.updateCommunity({ communityId: this.props.associatedCommunity._id, accountable: this.state.newAssignee, assigningUser: true, initiativeId: this.props.associatedCommunity.initiativeId, isRaciUpdated: this.state.radioValue === 1 ? false : this.props.associatedCommunity.isRaciUpdated })
        dispatch.initiatives.setAccountableForCommunity({ communityId: this.props.associatedCommunity._id, accountUserId: this.state.newAssignee.accountUserId, option: this.state.radioValue, isRaciUpdated: this.state.radioValue === 1 ? false : this.props.associatedCommunity.isRaciUpdated });
        if (this.props.initiativeStatus === 0) {
            dispatch.initiatives.getTeamMappingData({ organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.initiativeId, stopProcessing: this.props.stopProcessing, teamId: this.props.teamId });
            this.props.stopProcessing();
        }
        else {
            await dispatch.initiatives.getActiveInitiativeDetailsById(this.props.initiativeId);
            await dispatch.initiatives.getCommunityWiseActivities(this.props.initiativeId);

        }

        this.close();
    }
    handleChange = (e, { value }) => {
        this.setState({ radioValue: value });
    }
    render() {
        return (
            <Modal
                className="basicModal changeAssignee"
                open={this.props.open}
                size='small'
                closeOnEscape={false}
                closeOnDimmerClick={false}
                onClose={this.close}
            >
                <Modal.Header>Change Assignee</Modal.Header>
                <Divider />
                <Modal.Content>

                    <span>You are changing Assignee for role : <b>{this.props.associatedCommunity.name}</b></span>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={8} className="pad_0">
                                <React.Fragment >
                                    <div style={{ margin: "0 0 10px 0" }}>From</div>
                                    <ImageAvater user={this.props.associatedCommunity.accountable} />
                                    <EllipsisTooltip name={this.props.associatedCommunity.accountable.firstName + " " + this.props.associatedCommunity.accountable.lastName} />
                                </React.Fragment>
                            </Grid.Column>
                            <Grid.Column width={8} className="pad_0">
                                <React.Fragment >
                                    <div style={{ margin: "0 0 10px 0" }}>To</div>
                                    <Dropdown
                                        selection
                                        text={
                                            this.state.newAssignee ?
                                                <div >
                                                    <ImageAvater className="f_8 w_16 h_16 pad_2" user={this.state.newAssignee} avatar />
                                                    <EllipsisTooltip name={this.state.newAssignee.firstName + " " + this.state.newAssignee.lastName} />
                                                </div> :
                                                <div>
                                                    <ImageAvater className="f_8 w_16 h_16 pad_2" user={this.props.managers[0]} avatar />
                                                    <span className="user-dropdown-name">{this.props.managers[0].firstName + " " + this.props.managers[0].lastName}</span>
                                                </div>
                                        }
                                        style={{ width: "100%" }}
                                        onClick={this.searchUsers}
                                        className="userSelectionDropdown"
                                    >
                                        <Dropdown.Menu style={{}}>
                                            <Input focus placeholder='Search...' onChange={this.searchUsers} onClick={e => e.stopPropagation()} value={this.state.searchText} />
                                            {this.state.managers.length > 0 ?
                                                <React.Fragment >
                                                    <Dropdown.Divider />
                                                    <Dropdown.Header content='Managers' />
                                                    <Dropdown.Divider />
                                                    {this.state.managers.map((manager, i) => {
                                                        return <Dropdown.Item
                                                            key={i}
                                                            className="dropdownItems f_11"
                                                            text={<div><ImageAvater user={manager} className="f_8 w_16 h_16 pad_2" /><EllipsisTooltip name={manager.firstName + " " + manager.lastName} /></div>}
                                                            onClick={(event, data) => this.selectAccountableForCommunity(this.props.associatedCommunity, event, data)}
                                                            value={manager}
                                                        />
                                                    })}
                                                </React.Fragment>
                                                : null}

                                            {this.state.members.length > 0 ?
                                                <React.Fragment >
                                                    <Dropdown.Divider />
                                                    <Dropdown.Header content='Members' />
                                                    <Dropdown.Divider />
                                                    {this.state.members.map((member, i) => {
                                                        return <Dropdown.Item
                                                            key={i}
                                                            className="dropdownItems f_11"
                                                            text={<div> <ImageAvater user={member} className="f_8 w_16 h_16 pad_2" /><EllipsisTooltip name={member.firstName + " " + member.lastName} /></div>}
                                                            onClick={(event, data) => this.selectAccountableForCommunity(this.props.associatedCommunity, event, data)}
                                                            value={member} />
                                                    })}
                                                </React.Fragment>
                                                : null}

                                        </Dropdown.Menu>
                                    </Dropdown>
                                </React.Fragment>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Divider />
                <Modal.Content>
                    <Form noValidate
                        ref={ref => this.form = ref}
                        className="formcyForm"
                        name="issue"
                        id="issueid"
                        onValidSubmit={() => { this.addNotes() }}
                    >
                        <span>Select the type of changes which you would like to make: <br /><br /></span>
                        <Form.Field>
                            <Radio
                                label='Change Assignee only'
                                name='radioGroup'
                                value={0}
                                checked={this.state.radioValue === 0}
                                onChange={this.handleChange}
                            /><br />
                            <div style={{ textIndent: "24px" }}>This will only change Assignee at role level</div>
                        </Form.Field>
                        <Form.Field>
                            <Radio
                                label='Override Assignee and RACI for activities'
                                name='radioGroup'
                                value={1}
                                checked={this.state.radioValue === 1}
                                onChange={this.handleChange}
                            />
                            <br />
                            <div style={{ textIndent: "24px" }}>This will change Assignee at role level and RACI within all its activities.{this.props.initiativeStatus === 1 && <span style={{ textIndent: "24px" }}><br />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <sup style={{ color: 'red' }}>*</sup>Note:RACI for activities which have been completed will not be replaced</span>}
                            </div>
                        </Form.Field>
                    </Form >
                </Modal.Content>
                <Divider />
                <Modal.Actions className="actionInFormcy">
                    <Button className="button-cancel" type="button" onClick={this.close}>Cancel</Button>
                    <Button className="button-submit" type="submit" onClick={this.assignNewUser}>Save</Button>
                </Modal.Actions>
            </Modal >


        )
    }
}



export default ChangeAccountableConfirmationModal;